import axios, { AxiosError } from 'axios';
import { Api } from '../axios-config';
import { comOffline, somenteOnline } from '../../../offline/servico';
import { kvGet, kvSet } from '../../../offline/db';

export type TTipoImpressaoPdv = 'termica' | 'a4' | 'matricial' | 'naoimprimir';
export type TTipoPesquisaPdv = 'nome' | 'codigo' | 'codigobarras' | 'todos';

export interface IConfiguracaoPdv {
  idconfiguracaopdv: string;
  // Conta bancária padrão pra onde o PIX Estático é direcionado — configurada,
  // o operador não escolhe mais a conta na hora da venda (ver Dialogvenda.tsx).
  idcontapadraopix?: string;
  contapadraopixTitular?: string;
  tipoimpressao: TTipoImpressaoPdv;
  tipopesquisa: TTipoPesquisaPdv;
  // true (padrão): depois de finalizar a venda, abre a tela de impressão
  // (visualizar/reimprimir cupom, com o botão "Emitir nota" dentro dela).
  // false: pula essa tela e já abre direto a emissão da nota fiscal.
  preview: boolean;
}

export type TConfiguracaoPdvUpdate = Pick<IConfiguracaoPdv, 'idcontapadraopix' | 'tipoimpressao' | 'tipopesquisa' | 'preview'>;

interface ErrorResponse {
  errors?: { default: string };
}

const extractError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    const message = axiosError.response?.data?.errors?.default;
    if (message) return new Error(message);
    if (axiosError.request) return new Error('Nenhuma resposta do servidor');
    return new Error(axiosError.message);
  }
  return new Error('Erro inesperado');
};

const getOnline = async (): Promise<IConfiguracaoPdv | Error> => {
  try {
    const { data } = await Api.get('/configuracaopdv');
    return data;
  } catch (error) {
    return extractError(error);
  }
};

const updateOnline = async (dados: TConfiguracaoPdvUpdate): Promise<void | Error> => {
  try {
    await Api.put('/configuracaopdv', dados);
  } catch (error) {
    return extractError(error);
  }
};

const CHAVE_CONFIGURACAO = 'configuracaoPdv';

const get = (): Promise<IConfiguracaoPdv | Error> =>
  comOffline(
    getOnline,
    async () => (await kvGet<IConfiguracaoPdv>(CHAVE_CONFIGURACAO)) ?? new Error('Configuração do PDV indisponível offline.'),
    (configuracao) => kvSet(CHAVE_CONFIGURACAO, configuracao),
  );

const update = (dados: TConfiguracaoPdvUpdate) => somenteOnline(() => updateOnline(dados));

export const ConfiguracaoPdvService = {
  get,
  update,
};
